var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-medal-186825 (1) 1",
    clipPath: "url(#clip0_640_68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.3143 26H26.3203V32.002L19.8513 25.533C22.7653 24.771 25.3143 23.113 27.1623 20.847L32.3143 26ZM5.47231 20.848L0.320312 26H6.32031V31.998L12.7843 25.533C9.87131 24.771 7.32331 23.113 5.47231 20.848ZM28.3183 11.999C28.3183 18.628 22.9443 23.998 16.3193 23.998C9.69131 23.998 4.32031 18.628 4.32031 11.999C4.32031 5.375 9.69131 0 16.3193 0C22.9443 0 28.3183 5.375 28.3183 11.999ZM19.3423 13.894L24.3343 10H18.3393L16.3273 4L14.3233 10H8.32731L13.3193 13.944L11.3273 20.003L16.3343 16.269L21.3263 20.003L19.3423 13.894Z",
    fill: "url(#paint0_linear_640_68)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_68",
    x1: 16.3173,
    y1: 0,
    x2: 16.3173,
    y2: 32.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreIcon);
export default __webpack_public_path__ + "static/media/scoreIcon.3ec98ef11ed5f8d8e38c08f384a04781.svg";
export { ForwardRef as ReactComponent };